<template>
  <div id="recuperar-senha">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card card-login" style="margin-bottom: 40px">
            <div class="loader"></div>
            <div id="form">
              <h2 class="card-title text-center">Recuperar Senha</h2>
              <ValidationObserver ref="observer" class="row">
                <form @submit.prevent="recuperar()">
                  <div class="col-12">
                    <validation-provider
                      v-slot="{ errors }"
                      rules="required|cpf"
                    >
                      <div class="form-group input-group mb-0">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="icofont-card"></i>
                          </span>
                        </div>
                        <the-mask
                          v-model="cpf"
                          :mask="['###.###.###-##']"
                          class="cpf form-control"
                          placeholder="CPF"
                          required
                        />
                      </div>
                      <div class="error my-2">{{ errors[0] }}</div>
                    </validation-provider>
                  </div>
                  <div class="col-12">
                    <validation-provider v-slot="{ errors }" rules="required">
                      <div class="form-group input-group mb-0">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="icofont-envelope"></i>
                          </span>
                        </div>
                        <input
                          v-model="email"
                          type="email"
                          class="form-control"
                          placeholder="Email"
                          required
                        />
                      </div>
                      <div class="error my-2">{{ errors[0] }}</div>
                    </validation-provider>
                    <small class="form-text text-muded mb-2">
                      Insira o e-mail informado no momento do cadastro da sua
                      conta.
                    </small>
                  </div>
                  <div class="col-12">
                    <vue-recaptcha
                      @verify="onVerify"
                      sitekey="6LeX5zsrAAAAAGGgOymvPF0lZIiWIwmyYEc2q3jY"
                    >
                    </vue-recaptcha>
                  </div>
                  <div class="col-12">
                    <button
                      type="submit"
                      class="btn float-right"
                      :disabled="loading || counter > 0"
                    >
                      <span v-if="loading">
                        <b-spinner
                          label="Spinning"
                          small
                          variant="white"
                        ></b-spinner>
                      </span>
                      <span v-else-if="counter > 0">
                        Tente novamente em {{ counter }} segundos
                      </span>
                      <span v-else> Recuperar </span>
                    </button>
                  </div>
                </form>
              </ValidationObserver>
            </div>
          </div>
        </div>
        <div class="offset-md-4 col-md-4 col-12">
          <div class="d-flex align-items-center justify-content-center">
            <router-link to="/login">
              <button class="btn">
                <i class="icofont-arrow-left"></i> Voltar
              </button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'
import { TheMask } from 'vue-the-mask'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { validations } from '@/mixins/validations'
validations()

export default {
  components: {
    TheMask,
    'vue-recaptcha': VueRecaptcha,
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      cpf: '',
      email: '',
      loading: false,
      robot: false,
      counter: 0,
      timerInterval: null,
    }
  },
  methods: {
    /**
     * Verifica se o recaptcha foi selecionado
     *
     * @param {Object} respone
     */
    onVerify: function (response) {
      if (response) this.robot = true
    },

    /**
     * Recupera a senha do usuário
     */
    recuperar() {
      if (this.robot) {
        if (this.cpf == '') {
          this.$toast.info('Informe um CPF válido.', 'Erro:', {
            position: 'topRight',
          })
          return
        }

        if (this.email == '') {
          this.$toast.info(
            'Insira o e-mail informado no momento do cadastro da sua conta.',
            'Erro:',
            {
              position: 'topRight',
            }
          )
          return
        }

        let user = {
          cpf: this.cpf,
          email: this.email,
        }

        this.loading = true
        this.$apiPublic
          .post('/recuperar-senha', user)
          .then((response) => {
            this.$toast.info(response.data.message, '', {
              position: 'topRight',
            })
            this.robot = false
            this.loading = false
          })
          .catch((error) => {
            console.log(error)
            this.loading = false
            switch (error.response.status) {
              case 500:
                this.$toast.error(
                  'Erro ao recuperar senha! Por favor, entre em contato com o suporte.',
                  'Erro:',
                  {
                    position: 'topRight',
                  }
                )
                break
              default:
                break
            }
          })
          .finally(() => {
            this.loading = false
            this.startCountdown()
          })
      } else {
        this.$toast.error('Verificação inválida!', 'Erro:', {
          position: 'topRight',
        })
      }
    },

    /**
     * Habilita a contagem de segundos
     */
    startCountdown() {
      this.counter = 60
      this.timerInterval = setInterval(() => {
        if (this.counter > 0) {
          this.counter--
        } else {
          clearInterval(this.timerInterval)
          this.timerInterval = null
        }
      }, 1000)
    },
  },
}
</script>

<style>
#recuperar-senha {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.response-text {
  padding: 14px;
  background: #f2f2f2;
  margin: 40px auto;
}

.response-text h2 {
  margin-bottom: 0px;
  text-align: center;
}
</style>
